import { io } from "socket.io-client";

const socketUrl = import.meta.env.VITE_SOCKET_URL;
// const socketUrl = "http://192.168.1.18:8080";

const token = localStorage.getItem("token") || sessionStorage.getItem("token");
console.log("token+++++++",token)
const socket = io(socketUrl, {
    withCredentials: true,
    reconnectionAttempts: 5,
    transports: ["websocket"],
    autoConnect: false,
    auth: { token },
});

socket.on("connect", () => {
    console.log("Socket Connected:", socket.id);
});

socket.on("connect_error", (err) => {
    console.log("Socket Error:", err.message);
});

socket.on("disconnect", () => {
    console.log("Socket Disconnected");
});

export const connectSocket = () => {
    console.log("socket try to connect")
    const t = localStorage.getItem("token") || sessionStorage.getItem("token");
    if (t && !socket.connected) {
        socket.auth = { token: t };
        socket.connect();
    }
};

export const disconnectSocket = () => {
    if (socket.connected) socket.disconnect();
};

export default socket;